<template>
    <div class="container pt-2">
        <PageTitle main="Painel Administrativo" sub="Selecione o item desejado" />
        <div class="row justify-content-md-center mt-3">
            <b-button-group vertical>
                <b-button variant="success" style="width: 300px;" to="/categorias">Categorias</b-button>
                <b-button variant="primary" to="/subcategorias">Subcategorias</b-button>
                <b-button variant="secondary" to="/tipoServico">Serviços</b-button>
            </b-button-group>
        </div>
        <div class="row justify-content-md-center mt-3">
            <b-button-group vertical>
                <b-button variant="info" style="width: 300px;" to="/confirmaJobs">Confirmar Pagamento do Job</b-button>
                <b-button variant="warning" to="/validaJobs">Validar Job</b-button>
            </b-button-group>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    
    name: "Admin",
    data: function() {
        return {
            jwt: new VueEasyJwt()
        }
    },
    computed: {},
    components: { PageTitle },
    methods: {
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
    }
}
</script>

<style>
</style>